export default "__VITE_ASSET__JAhCxBin__"